/**
 * @generated SignedSource<<69fe4b1ae49101ed737d416416098410>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type emptyView_softwareReleasesVersionDetailIssueList$data = {
  readonly canAddAndRemoveIssues: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion">;
  readonly " $fragmentType": "emptyView_softwareReleasesVersionDetailIssueList";
} | null | undefined;
export type emptyView_softwareReleasesVersionDetailIssueList$key = {
  readonly " $data"?: emptyView_softwareReleasesVersionDetailIssueList$data;
  readonly " $fragmentSpreads": FragmentRefs<"emptyView_softwareReleasesVersionDetailIssueList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "emptyView_softwareReleasesVersionDetailIssueList",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "canAddAndRemoveIssues"
      },
      "action": "LOG",
      "path": "canAddAndRemoveIssues"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "e747dc1997c64c6a07fe54d01ff7878c";

export default node;
